import { useMemo, useState } from 'react';
import Raven from 'raven-js';
import I18n from 'I18n';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import InviteReminderBanner from 'setup-guide-components/components/banner/InviteReminderBanner';
import { useLatestInvites } from 'setup-guide-api/dataFetchingClient/queries/invite';
import { useInviteReminderBannerState } from '../hooks/inviteReminder';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InviteReminderModalContainerAsync = Loadable({
  loader: () => import( /* webpackChunkName: "invite-reminder-modal" */'./InviteReminderModalContainer'),
  LoadingComponent: () => null
});
const InviteReminderBannerContainer = () => {
  const [showModal, setShowModal] = useState(false);
  const [shouldShowBanner, setShouldShowBanner] = useInviteReminderBannerState();
  const {
    data: latestInvites
  } = useLatestInvites({
    skip: !shouldShowBanner,
    onError: error => {
      Raven.captureException(new Error('Error on getting latest invites'), {
        extra: {
          message: error.message
        }
      });
    }
  });
  const recentInvites = useMemo(() => {
    if (!latestInvites) {
      return [];
    }
    return latestInvites.filter(invite => Date.now() - invite.createdAt > 86400000);
  }, [latestInvites]);
  if (!shouldShowBanner || recentInvites.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(InviteReminderBanner, {
      invites: recentInvites,
      onButtonClick: () => {
        setShowModal(true);
      },
      onClose: () => {
        setShouldShowBanner(false);
      }
    }), showModal && /*#__PURE__*/_jsx(InviteReminderModalContainerAsync, {
      invites: recentInvites,
      onClose: () => {
        setShowModal(false);
      },
      onInviteRemindersSent: () => {
        setShowModal(false);
        setShouldShowBanner(false);
        FloatingAlertStore.addAlert({
          message: I18n.text('app.inviteReminderBanner.resentReminder.message'),
          titleText: I18n.text('app.inviteReminderBanner.resentReminder.title'),
          type: 'success'
        });
      }
    })]
  });
};
export default InviteReminderBannerContainer;